<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- 3. Hide results -->
    <div
      class="hide-result-form result-settings-option mb-2 pl-0.5"
      ref="form-check-hide-results"
      v-if="hideResultsVisible"
    >
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="mr-2 custom-control-input"
          id="check-hide-result"
          v-model="isShowResultOnPresenterScreen"
          @change="updateSettingSlide(3)"
        />
        <label class="custom-control-label" for="check-hide-result">
          {{ $i18nPresenter.t('Hide results') }}
        </label>
        <span class="pl-1 pr-3 title-table-presentation-tooltip">
          <b-button
            v-tooltip="$i18nPresenter.t(`Hide participants' votes while other participants are still voting. This helps prevent voting bias.`)"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
        <a
          :class="{'disabled': isDisableWhenNotOwner}"
          class="button-show-all right-col--link"
          @click="updateStatusResult"
        >
          {{ $i18nPresenter.t('Apply on all questions') }}
        </a>
      </div>
    </div>

    <!-- Show voting results on audience's phone -->
    <div
      class="hide-result-form result-settings-option mb-2 pl-0.5"
      ref="form-check-hide-results"
      v-if="showVotingResultsOnAudienceVisible"
    >
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-show-voting-results-on-audience"
          v-model="slideActive.showVotingResultsOnAudience"
          @change="updateSettingSlide(17)"
        />
        <label class="custom-control-label" for="check-show-voting-results-on-audience">
          {{ $i18nPresenter.t('Show on audience’s devices') }}
        </label>
        <span class="pl-1 pr-3 title-table-presentation-tooltip">
          <b-button
            v-tooltip="showVotingResultsOnAudienceTooltip"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
    </div>

    <!-- Show results in % for this question -->
    <div
      class="result-settings-option pl-0.5"
      v-if="slideActive.type == 'multipleChoice' || slideActive.type == 'imageChoice'"
    >
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-show-percentage"
          v-model="slideActive.showPercentage"
          @change="updateSettingSlide(8)"
        />
        <label class="custom-control-label" for="check-show-percentage">{{ $i18nPresenter.t('Show in percentage (%)') }}</label>
        <span class="pl-1 title-table-presentation-tooltip">
          <b-button
            v-tooltip="$i18nPresenter.t(`You can also switch this on / off by clicking on the chart while you\'re presenting`)"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Config from '@/config'
import Utils from '@/util'
import Socket from '@/socket'

export default {
  name: 'ResultVisibilitySettings',
  props: {
    updateSettingSlide: {
      type: Function,
      default: () => { },
    },
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters(['isDisableWhenNotOwner']),
    showVotingResultsOnAudienceVisible() {
      const slideTypes = ['multipleChoice', 'imageChoice']
      return slideTypes.includes(this.slideActive.type)
    },
    isShowResultOnPresenterScreen: {
      get() {
        return this.slideActive.hideResult
      },
      set(val) {
        this.slideActive.hideResult = val
      },
    },
    hideResultsVisible() {
      const slideTypes = ['bulletPoints', 'pickAnswer', 'leaderboard', 'question', 'ideas']
      return !slideTypes.includes(this.slideActive.type)
    },
    showVotingResultsOnAudienceTooltip() {
      return this.$i18nPresenter.t('Allow your audience to see the vote count on their devices. Leave unchecked to prevent voting bias.')
    },
  },
  methods: {
    updateStatusResult() {
      if (this.isDisableWhenNotOwner) {
        return
      }
      this.$store.dispatch('setSyncPresentation', 1)
      this.$http
        .post(Config.api.updateStatusResult, {
          id: this.$store.state.presentation.id,
          hideResult: this.slideActive.hideResult,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
        })
        .then(
          () => {
            this.$store.dispatch('setSyncPresentation', 2)

            if (!this.slideActive.hideResult) {
              Utils.showToastSuccess(this.$i18nPresenter.t('Results on all slides are now shown.'))
            } else {
              Utils.showToastSuccess(this.$i18nPresenter.t('Results on all slides are now hidden.'))
            }

            this.$store.state.presentation.slides.forEach((item) => {
              item.hideResult = this.slideActive.hideResult
            })
            this.$store.state.presentation.slides.push()

            Utils.mixpanelTracking(
              'Presentation',
              'Results all slide',
              'Presenter edit show/hide results all slide',
              this.slideActive.hideResult,
            )
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },
  },
}
</script>

<style lang="scss">
.result-settings-option {
  .title-table-presentation-tooltip {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  &:hover .title-table-presentation-tooltip {
    opacity: 1;
  }
}
.button-show-all {
  position: absolute;
  max-width: 250px;
  margin-left: 8px;
  margin-top: -4px;
  border: none;
  line-height: 29px;
  font-size: 14px;
  &.disabled{
    &:hover{
      cursor: not-allowed;
      color: inherit !important;
      text-decoration: underline !important;
    }
  }
}
</style>
